import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { ZpDataService } from "../services/zp-data.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomValidators } from "../custom-validators";
import { AdminDashboardService } from "src/app/services/admin-dashboard.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { ThemeService } from "../theme/theme-service.service";
import { DelegateHelpers } from "../helpers/delegate-helpers";
import { ActivatedRoute, Router } from "@angular/router";
import plantree from "../../assets/data/plan-tree.json";
import { PreviousUrlService } from "../services/previous-url.service";
import { IUser } from "../models/user.model";
import { DatePipe } from "@angular/common";
import { NotificationService } from "../services/notification.service";
import { ZPNotification } from "../models/zpnotification";
import { ProfessionalFeaturesService } from "../services/professional-features.service";

@Component({
    selector: "app-professional-home-page",
    templateUrl: "./professional-home-page.component.html",
    styleUrls: ["./professional-home-page.component.scss"],
    host: {
        "(window:click)": "closeFromOutside()",
    },
    standalone: false
})
export class ProfessionalHomePageComponent implements OnInit {
  @ViewChild("textarea") public textarea: ElementRef<HTMLTextAreaElement>;
  @ViewChild("myModal") public myModal: ElementRef;
  @ViewChild("warningModal") public warningModal: ElementRef;
  public customers;
  public user: IUser = {} as IUser;
  public userBeingEdited;
  public refCode: string;
  public submitted: boolean = false;
  public showTeamMateAddView: boolean = false;
  public showTeamMateUpdateView: boolean = false;
  public currentlyEditingMember: {
    password: "";
    email: "";
    name: "";
    phone: "";
  };
  public createNewMemberForm: FormGroup;
  public statusPassword: boolean = false;
  public capsOn: boolean;
  public logoUrl: string;
  public clientSignUpLink: string =
    "Your professionals can sign up to Zenplans using this unique link.";
  public clientLink: string = "https://app.zenplans.com/";
  public clientIntroEmail: string =
    "Email templates to help you introduce Zenplans to your clients.";
  public changeLogoTooltip: string =
    "Click the button and select a new logo to represent your company.";
  public dataIsLoaded: boolean;
  public currentFile: File;
  public message: string;
  public list = [];
  public section = "professionals_config";
  public item: any;
  public itemIsNotSaved: boolean;
  public statusResources: boolean = false;
  public professionalsDelegates: any;
  public statusTeamMembers: boolean = false;
  public statusClientIssues: boolean = false;
  public statusSuggestions: boolean = false;
  public statusCustomBlocks: boolean = false;
  public statusMessages: boolean = false;
  public statusDelegateNetwork: boolean = true;
  public statusAttachments: string;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public clientsFeed: any;
  public userNameLookup = {};
  public userEvent: any;
  public subscription: Promise<void>;
  public mySharedPlans: any;
  public planInClientsFeedSharedPlans = [];
  public hideSponsor: any;
  public newArray: any = [];
  public viewButton: boolean = false;
  public showViewButton = {};
  public previousLink: string;
  public emailSubject: string;
  public emailBody: string;
  public modalTitle: string;
  public nudgeEmailToSend: {
    mailSubject: string;
    mailBody: string;
    mode: string;
    userList: any;
  };
  public inputEmailSubject: string;
  public selectedUserId: any;
  public filteredCustomers = []; // Array to store filtered customers
  public statusFilter: any;
  public emailTemplate: any;
  public emailTemplateNudge: any;
  public emailTemplateDelegate: any;
  public insertFieldValues: any;
  public searchTerm: string = "";
  public editableTemplateBody: string;
  public isChecked: boolean = false;
  public selectedSection: string = "";
  public hoveredRowIndex: number | null = null;
  public firstNameSorted: boolean = false;
  public lastNameSorted: boolean = false;
  public linkedClientSorted: boolean = false;
  public ageSorted: boolean = false;
  public sortedUsers: any;
  @ViewChild("dropdownMenu") public dropdownMenu: ElementRef;
  public originalProfessionalsDelegates: any[] = [];
  public selectedRelations: string[] = [];
  public isDropdownOpen: boolean = false;
  public relations = [
    { label: "Spouse", checked: false },
    { label: "Child", checked: false },
    { label: "Sibling", checked: false },
    { label: "Parent", checked: false },
    { label: "Accountant", checked: false },
    { label: "Solicitor", checked: false },
    { label: "Wealth Manager", checked: false },
    { label: "Professional Advisor", checked: false },
    { label: "Friend", checked: false },
    { label: "Partner", checked: false },
    { label: "Other", checked: false },
  ];
  public company: string;
  public sponsorLastName: string;
  public sponsorFirstName: string;
  public uploadLogo;
  public displaySections: boolean;
  public displayLoader: boolean;
  public companyDetails: {
    userType?: string;
    professionalLicense?: string;
    funded?: boolean;
    hideSponsor?: boolean;
    directInvoice?: boolean;
    email?: string;
    company?: string;
    logo?: string;
    firstName?: string;
    lastName?: string;
    client_access_page?: string;
    advisor_hub?: string;
  };
  public textSignUpCopied: boolean;
  public textClientAccessCopied: boolean;
  public textAdvisorHub: boolean;
  public selectedUserData: any = {};
  public messageToSend: string = "";
  public messageHasBeenSent: boolean = false;
  public retrievedMessagesLength: number;
  public displayUnreadMessageBadge: boolean;
  @ViewChild("closeButton") public closeButton: ElementRef;
  public totalUnreadMessages: number;
  public retrievedMessages: any;
  public statusOpenModal: boolean;
  public statusRedirectionModal: boolean;
  accountCreated: any;
  userToCreate: {
    customizedMailBody: string;
    mailBody: string;
    mailSubject: string;
    reminder: string;
    prePopulate: boolean;
    Id: string;
    userList: { firstName: any; lastName: any; email: any }[];
  };
  openModalForAccountCreation: boolean;
  modalForClientCreation: boolean = false;
  modalMessage: string;
  userToBeCreated: any;
  openExplanationsForStatus: boolean;
  userToRemoteStorage: { selectedUserId: string; nudgeSent: boolean };
  userWithPrepopulated: any = null;
  public nudgeModalCanBeOpened: boolean;
  public warningModalCanBeOpened: boolean;
  public modalCanBeOpened: boolean;
  templateKey: any;

  constructor(
    private api: ZpDataService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private formBuilder: FormBuilder,
    private adminDashboardService: AdminDashboardService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService,
    private delegateHelpers: DelegateHelpers,
    private router: Router,
    private previousUrl: PreviousUrlService,
    private datePipe: DatePipe,
    private zpDataService: ZpDataService,
    private notifications: NotificationService,
    private route: ActivatedRoute,
    private professionalFeaturesService: ProfessionalFeaturesService
  ) {
    this.item = { content: "" };
    if (window["WHITE_LABEL_SITE_URL"]) {
      this.clientLink = window["WHITE_LABEL_SITE_URL"];
    }
    this.userEvent = {
      attachment: "Added an attachment",
      cancel_account: "Cancelled their account",
      item_add: "Added an item",
      item_deleted: "Deleted an item",
      item_deleted_permanently: "Permanently deleted and item",
      item_update: "Updated an item",
      login_success: "Logged in",
      new_delegate_upsert: "Added a new delegate",
      registered_delegate_upsert: "Added a new delegate",
      request_for_access: "Requested access to a locked plan",
      response_for_access:
        "Received a response to their request for access to a locked plan",
      restored: "Restored an item they had previously deleted",
      shared_item_add: "Added a new item to a shared plan as a delegate",
      shared_item_update:
        "Updated an existing item to a shared plan as a delegate",
      user_details_update: "Updated their user details",
      user_or_delegate_deleted: "Removed a delegate",
      user_registration: "Signed up",
      user_update: "Updated their user details",
    };
  }

  async updateScreen() {
    try {
      const user = await this.api.getUser();
      this.user = user;
      console.log("user: ", user);
      this.refCode = user.license.refCode;
      const checkExclusiveRefcode = await this.api.retrieveValidRefCode(
        this.refCode
      );
      this.hideSponsor = checkExclusiveRefcode.hideSponsor;
      console.log("checkExclusiveRefcode: ", checkExclusiveRefcode);
      if (checkExclusiveRefcode.exclusive == true) {
        this.isChecked = true;
      } else {
        this.isChecked = false;
      }
      if (user && user.attachments) {
        const logo = user.attachments.find((a) => a.fileName == "logo");
        if (logo && user.license && user.license.refCode) {
          this.logoUrl = await this.api.getLogoUrl(user.license.refCode);
          console.log('logoUrl: ', this.logoUrl);
        } else {
          this.logoUrl = '';
        }
      } else {
        this.logoUrl = '';
      }
      if (user.attachments === undefined) {
        this.statusAttachments = "empty";
        user["statusAttachments"] = this.statusAttachments;
        this.getInfoAndPassService.getInfoAndPass(this.statusAttachments);
      }
    } catch (error) {
      console.error("An error occurred. Couldn't get the refcode.", error);
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener("document:click", ["$event"])
  closeFromOutside(event: Event) {
    if (
      this.isDropdownOpen &&
      event &&
      !this.dropdownMenu.nativeElement.contains(event.target)
    ) {
      this.isDropdownOpen = false;
    }
  }

  async ngOnInit() {
    this.displayLoader = true;
    this.previousLink = this.previousUrl.getPreviousUrl();
    console.log("previousLink: ", this.previousLink);
    if (
      this.previousLink === "/log-in" ||
      this.previousLink === "/auth" ||
      this.previousLink.includes("/account-created")
    ) {
      window.location.reload();
    }
    this.statusFilter = null;
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    this.customers = [];
    this.api.getCustomers().then((customers) => {
      this.customers = customers;
      console.log("All customers: ", this.customers);
      this.customers.forEach((customer) => {
        if (!customer.firstName && !customer.lastName) {
          this.userNameLookup[customer.clientId] = customer.email;
        } else {
          this.userNameLookup[customer.clientId] =
            customer.firstName + " " + customer.lastName;
        }
      });
      if (this.customers.length > 0) {
        this.filterCustomers();
      }
    });
    this.displayCurrentSection("clients");
    this.api.getFeedClients().then((clients) => {
      this.clientsFeed = clients.clientFeed;
      console.log("clientsFeed - ", this.clientsFeed);
    });
    this.updateScreen();
    this.insertFieldValues =
      await this.api.getProfessionalInviteTemplatePlaceholders();
    console.log("myUser: ", this.user);
    this.subscription = this.api.getUser().then(async (user) => {
      this.user = user;
      this.setCompanyDetails(this.user);

      this.mySharedPlans = await this.api.getSharedPlans(this.user);
      console.log("mySharedPlans - ", this.mySharedPlans);
      let clientsFeedSharedPlans = [];

      for (
        let sharedPlan = 0;
        sharedPlan < this.mySharedPlans.length;
        sharedPlan++
      ) {
        clientsFeedSharedPlans.push(this.mySharedPlans[sharedPlan]);

        if (this.clientsFeed) {
          for (
            let clientFeed = 0;
            clientFeed < this.clientsFeed.length;
            clientFeed++
          ) {
            if (
              this.clientsFeed[clientFeed].user ==
              clientsFeedSharedPlans[sharedPlan].clientId
            ) {
              this.clientsFeed[clientFeed].sharedPlan = true;
              this.planInClientsFeedSharedPlans.push(
                this.clientsFeed[clientFeed]
              );
              for (let itemPlan = 0; itemPlan < plantree.length; itemPlan++) {
                let sectionObjects = plantree[itemPlan].sectionObjects;
                if (sectionObjects) {
                  for (
                    let sectionObject = 0;
                    sectionObject < sectionObjects.length;
                    sectionObject++
                  ) {
                    if (
                      sectionObjects[sectionObject].section ==
                      this.clientsFeed[clientFeed].section
                    ) {
                      this.showViewButton[this.clientsFeed[clientFeed]._id] =
                        true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    });
    this.createNewMemberForm = this.formBuilder.group({
      name: ["", Validators.required],
      email: ["", [Validators.email, Validators.required]],
      phone: ["", Validators.required],
      password: [
        "",
        Validators.compose([
          Validators.required,
          // check whether the entered password has a number
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true,
          }),
          // check whether the entered password has a special character
          CustomValidators.patternValidator(/[!@#$%^&*(),.?":{}|<>]/, {
            hasSpecialSymbol: true,
          }),
          // check whether the entered password has upper case letter
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true,
          }),
          // check whether the entered password has a lower case letter
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true,
          }),
          Validators.minLength(10),
        ]),
      ],
    });
    this.reloadList();
    this.nudgeEmailToSend = {
      mailBody: "",
      mailSubject: "",
      mode: "nudge",
      userList: [],
    };
    this.loadTemplates();
    setTimeout(() => {
      this.calculateMfaEmailCount();
    }, 1000);
    this.handleUnreadMessages();
  }

  async checkRemoteStorageForPrepopulatedUser(customers?: any) {
    const getRemoteStorage = await this.api.getRemoteStorage();
    console.log("getRemoteStorage on init: ", getRemoteStorage);

    // Ensure getRemoteStorage is an array and has at least one entry
    if (!Array.isArray(getRemoteStorage) || getRemoteStorage.length === 0) {
      console.error("No data found in remote storage array");
      return;
    }

    // Iterate through filteredCustomers and update their shared status based on remote storage
    if (customers && customers.length > 0) {
      console.log("customers: ", customers);
    
      customers.forEach((customer) => {
        console.log("customer: ", customer);
        
        // Define userKey for the current customer
        const userKey = customer.Id;
        let emailShared = false; // Default status
    
        // Iterate over the remoteStorage array
        getRemoteStorage.forEach((storageEntry) => {
          const nestedData = storageEntry.data.data; // Extract the nested 'data.data'
    
          // Check if customer data exists in the remoteStorage data
          const customerData = nestedData[userKey];
          if (customerData) {
            // Update emailShared based on 'emailStatus' and 'bannerToDisplayInSharedPlanSummary'
            if (
              (customerData.emailStatus && customerData.emailStatus.nudgeSent) ||
              (customerData.bannerToDisplayInSharedPlanSummary && customerData.bannerToDisplayInSharedPlanSummary.nudgeSent)
            ) {
              emailShared = true;
            }
          } else {
            console.warn(`No data found for key: ${userKey}`);
          }
        });
    
        // Set the customer's emailShared status and log the result
        customer.emailShared = emailShared;
        console.log(`customer ${emailShared ? "shared" : "not shared"} - `, customer);
      });
    
      console.log("Updated filteredCustomers with shared status: ", this.filteredCustomers);
    }
    
  }

  async setCompanyDetails(user?: IUser) {
    this.refCode = user.license.refCode;
    console.log("refCode - ", this.refCode);
    await this.api.setRefCode(this.refCode);
    // this.logoUrl = await this.api.getLogoUrl(user.refCode);
    this.companyDetails =
      (await this.api.getRefCodeInfo()) && this.api.getRefCodeInfo();
    console.log("companyDetails - ", this.companyDetails);
    if (this.hideSponsor || !this.hideSponsor) {
      this.displayLoader = false;
    }
    this.fetchData(this.companyDetails);

    // return this.companyDetails;
  }

  async fetchData(companyDetails) {
    console.log("companyDetails - ", companyDetails);
    this.hideSponsor = companyDetails.hideSponsor;
    this.originalProfessionalsDelegates =
      await this.api.getProfessionalsDelegates();
    console.log(
      "originalProfessionalsDelegates: ",
      this.originalProfessionalsDelegates
    );
    this.updateFilteredData(companyDetails);
  }

  onRelationSelectionChange() {
    // Don't need to limit the number of selected relations anymore
    this.updateFilteredData();
  }

  updateFilteredData(companyDetails?: any) {
    // check in the company details object if the email is the same as one of the original professionals delegates
    const selectedRelationLabels = this.relations
      .filter((relation) => relation.checked)
      .map((relation) => relation.label);

    if (selectedRelationLabels.length > 0) {
      this.professionalsDelegates = this.originalProfessionalsDelegates.filter(
        (dataUser) => selectedRelationLabels.includes(dataUser.delegateRelation)
      );
    } else {
      // If no relations are selected, show all original data excluding the one with companyDetails.email
      if (companyDetails && companyDetails.email) {
        this.professionalsDelegates =
          this.originalProfessionalsDelegates.filter(
            (dataUser) => companyDetails.email !== dataUser.delegateEmail
          );
      } else {
        // Handle the case where companyDetails or companyDetails.email is undefined
        this.professionalsDelegates =
          this.originalProfessionalsDelegates.slice();
      }
    }
  }

  calculateAge(dateOfBirth: string): number | string {
    if (dateOfBirth !== undefined) {
      const isFormatYYYYMMDD = /^\d{4}-\d{2}-\d{2}$/.test(dateOfBirth);
      if (isFormatYYYYMMDD) {
        const dobDate = new Date(dateOfBirth);
        if (isNaN(dobDate.getTime())) {
          return "";
        }
        const today = new Date();
        const age = today.getFullYear() - dobDate.getFullYear();
        if (
          today <
          new Date(today.getFullYear(), dobDate.getMonth(), dobDate.getDate())
        ) {
          return age - 1;
        }
        return age;
      }
      const parts = dateOfBirth.split("/");
      if (parts.length === 3) {
        const formattedDateOfBirth = `${parts[1]}/${parts[0]}/${parts[2]}`;
        const dobDate = new Date(formattedDateOfBirth);

        if (isNaN(dobDate.getTime())) {
          return "";
        }
        const today = new Date();
        const age = today.getFullYear() - dobDate.getFullYear();

        if (
          today <
          new Date(today.getFullYear(), dobDate.getMonth(), dobDate.getDate())
        ) {
          return age - 1;
        }
        return age;
      }
      return "";
    }
  }

  setHoveredRow(index: number): void {
    this.hoveredRowIndex = index;
  }

  clearHoveredRow(): void {
    this.hoveredRowIndex = null;
  }

  setStatusFilter(status: string) {
    this.statusFilter = status;
    this.filterCustomers();
  }

  async handleAllowInvite() {
    const validRefCode = await this.api.retrieveValidRefCode(this.refCode);
    console.log("validRefcode: ", validRefCode);
    if (this.isChecked) {
      console.log("checked");
      validRefCode.exclusive = true;
      this.api.refferalCodeUpdate(validRefCode, this.refCode);
    } else {
      validRefCode.exclusive = false;
      this.api.refferalCodeUpdate(validRefCode, this.refCode);
    }
  }

  filterCustomers() {
    if (this.statusFilter === null) {
      this.filteredCustomers = this.customers;
    } else if (this.statusFilter === "invited") {
      this.filteredCustomers = this.customers.filter(
        (customer) => customer.userType === "invited"
      );
    } else if (this.statusFilter === "created") {
      this.filteredCustomers = this.customers.filter(
        (customer) =>
          customer.userType === "planHolder" && customer.isDelegate === false
      );
    } else if (this.statusFilter === "delegate") {
      this.filteredCustomers = this.customers.filter(
        (customer) =>
          customer.userType === "planHolder" && customer.isDelegate === true
      );
    } else if (this.statusFilter === "prePopulatedNotShared") {
      this.filteredCustomers = this.customers.filter(
        (customer) =>
          customer.userType === "prePopulated" && !customer.emailShared
      );
    } else if (this.statusFilter === "prePopulatedShared") {
      this.filteredCustomers = this.customers.filter(
        (customer) =>
          customer.userType === "prePopulated" && customer.emailShared
      );
    }

    // Search filtering
    if (this.searchTerm && this.searchTerm.trim() !== "") {
      const searchTermLower = this.searchTerm.toLowerCase();
      this.filteredCustomers = this.filteredCustomers.filter((customer) => {
        const fullName = (
          customer.firstName +
          " " +
          customer.lastName
        ).toLowerCase();
        return fullName.includes(searchTermLower);
      });
    }

    // Check prepopulated user from remote storage
    this.checkRemoteStorageForPrepopulatedUser(this.filteredCustomers);
  }

  calculateMfaEmailCount() {
    this.filteredCustomers.forEach((customer) => {
      const emailHistory: any[] = customer.email_history;
      let nudgeEmailCount = 0;
      let lastEmailTime = 0;
      if (emailHistory) {
        emailHistory.forEach((email: any) => {
          if (email.template === "__nudge") {
            nudgeEmailCount++;
            const emailTime = email.date;
            if (emailTime > lastEmailTime) {
              lastEmailTime = emailTime;
            }
          }
        });
      }
      const formattedLastEmailTime = this.datePipe.transform(
        lastEmailTime,
        "short"
      );
      customer.nudgeEmailCount = nudgeEmailCount;
      customer.lastEmailTime = formattedLastEmailTime;
    });
  }

  getTooltipText(customer: any): string {
    if (customer.nudgeEmailCount > 0) {
      const formattedLastEmailTime = this.datePipe.transform(
        customer.lastEmailTime,
        "dd.MM.yyyy"
      );
      return `Last Nudge Sent: ${formattedLastEmailTime} Total Nudges Sent: ${customer.nudgeEmailCount}`;
    } else {
      return "No nudges have been sent.";
    }
  }

  getTooltipForDelegate(delegate) {
    if (delegate.delegateIsExecutor && delegate.delegateIsAttorney) {
      return "Executor + Attorney";
    } else if (delegate.delegateIsExecutor) {
      return "Executor";
    } else if (delegate.delegateIsAttorney) {
      return "Attorney";
    }
  }

  async reloadList() {
    this.list = await this.api.getProfessionalResource();
    if (this.list.length) {
      this.item = this.list[0];
    }
  }

  get f() {
    return this.createNewMemberForm.controls;
  }

  get createMemberErrorMessages(): string[] {
    const messages: string[] = [];
    const c = this.createNewMemberForm.controls;

    if (c.name.hasError("required")) {
      messages.push("User's Name is required.");
    }
    if (c.email.hasError("required")) {
      messages.push("User's Email is required.");
    } else if (c.email.hasError("email")) {
      messages.push("User's Email must be a valid email address.");
    }
    if (c.phone.hasError("required")) {
      messages.push("User's Phone is required.");
    }
    if (c.password.hasError("required")) {
      messages.push("User's Password is required.");
    } else {
      if (c.password.hasError("minlength")) {
        messages.push("Password must be at least 10 characters.");
      }
      if (c.password.hasError("hasCapitalCase")) {
        messages.push("Password must contain at least 1 capital letter.");
      }
      if (c.password.hasError("hasSmallCase")) {
        messages.push("Password must contain at least 1 lowercase letter.");
      }
      if (c.password.hasError("hasNumber")) {
        messages.push("Password must contain at least 1 number.");
      }
      if (c.password.hasError("hasSpecialSymbol")) {
        messages.push("Password must contain at least 1 special character.");
      }
    }
    return messages;
  }

  async onSubmit() {
    this.submitted = true;
    if (this.createNewMemberForm.invalid) {
      return;
    }
    this.api
      .addOrUpdateTeamMember(this.createNewMemberForm.value)
      .then((response) => {
        this.showTeamMateAddView = false;
        this.updateScreen();
      });
  }

  editTeamMember(teamMember: any) {
    teamMember.password = null;
    this.showTeamMateUpdateView = true;
    this.currentlyEditingMember = teamMember;
  }

  updateTeamMember() {
    if (
      !this.currentlyEditingMember.password ||
      this.currentlyEditingMember.password == ""
    ) {
      // || this.currentlyEditingMember.password.length >= 4
      delete this.currentlyEditingMember.password;
    }
    this.api
      .addOrUpdateTeamMember(this.currentlyEditingMember)
      .then((response) => {
        this.showTeamMateUpdateView = false;
        this.currentlyEditingMember = undefined;
        this.updateScreen();
      });
  }

  removeTeamMember(email) {
    var member = this.user.team.find((m) => m.email == email);
    this.api.deleteTeamMember(member).then((response) => {
      this.updateScreen();
    });
  }

  async fileUpload(element) {
    this.dataIsLoaded = false;
    this.currentFile = await this.api.uploadFile(
      element.target.files[0],
      this.user.clientId,
      "logo"
    );
    let result = await this.api.uploadFile(
      element.target.files[0],
      this.user.clientId,
      "logo"
    );
    if (result.success) {
      this.dataIsLoaded = true;
      window.location.reload();
    } else {
      this.message = "Sorry, your file could not be uploaded.";
    }
  }

  copyText(val: string, linkType: string) {
    let selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    if (linkType === "clientSignUpLink") {
      this.textSignUpCopied = true;
    }
    if (linkType === "clientAccessPage") {
      this.textClientAccessCopied = true;
    }
    if (linkType === "advisorHub") {
      this.textAdvisorHub = true;
    }
    setTimeout(() => {
      this.textSignUpCopied = false;
      this.textClientAccessCopied = false;
      this.textAdvisorHub = false;
    }, 3000);
  }

  seeSharedPlan($event, index, section, chosenPlan, professional) {
    let treeSection = section;
    let treeCategory;
    for (let itemPlan = 0; itemPlan < plantree.length; itemPlan++) {
      let sections = plantree[itemPlan].sectionObjects;
      if (sections) {
        for (let section = 0; section < sections.length; section++) {
          if (sections[section].section === treeSection) {
            treeCategory = plantree[itemPlan].planCategory;
          }
        }
      }
    }
    switch (treeCategory) {
      case "my assets":
        this.checkSharedPlanRightAccess(
          "assets",
          "/my-assets/",
          chosenPlan,
          index,
          professional
        );
        break;
      case "my debts":
        this.checkSharedPlanRightAccess(
          "debts",
          "/my-debts/",
          chosenPlan,
          index,
          professional
        );
        break;
      case "my daily life":
        this.checkSharedPlanRightAccess(
          "dailyLife",
          "/my-daily-life/",
          chosenPlan,
          index,
          professional
        );
        break;
      case "my wishes":
        this.checkSharedPlanRightAccess(
          "wishes",
          "/my-wishes/",
          chosenPlan,
          index,
          professional
        );
        break;
      case "my digital life":
        this.checkSharedPlanRightAccess(
          "digitalLife",
          "/my-digital-life/",
          chosenPlan,
          index,
          professional
        );
        break;
      default:
        console.log("test ");
    }
  }

  checkSharedPlanRightAccess(
    chosenSection,
    navigateSection,
    chosenPlan,
    index,
    professional
  ) {
    for (
      let sharedPlan = 0;
      sharedPlan < this.mySharedPlans.length;
      sharedPlan++
    ) {
      if (this.mySharedPlans[sharedPlan].clientId === chosenPlan) {
        switch (chosenSection) {
          case "assets":
            if (
              this.mySharedPlans[sharedPlan].assetsPermission != "never" &&
              this.mySharedPlans[sharedPlan].assetsPermission != "future"
            ) {
              this.delegateHelpers.seeSharedPlan(
                chosenSection,
                this.mySharedPlans[sharedPlan],
                this.user,
                professional
              );
              this.router.navigate([navigateSection + chosenPlan["clientId"]]);
            } else {
              this.disableAccessButton(index);
            }
            break;
          case "debts":
            if (
              this.mySharedPlans[sharedPlan].debtsPermission != "never" &&
              this.mySharedPlans[sharedPlan].debtsPermission != "future"
            ) {
              this.delegateHelpers.seeSharedPlan(
                chosenSection,
                this.mySharedPlans[sharedPlan],
                this.user,
                professional
              );
              this.router.navigate([navigateSection + chosenPlan["clientId"]]);
            } else {
              this.disableAccessButton(index);
            }
            break;
          case "dailyLife":
            if (
              this.mySharedPlans[sharedPlan].dailyLifePermission != "never" &&
              this.mySharedPlans[sharedPlan].dailyLifePermission != "future"
            ) {
              this.delegateHelpers.seeSharedPlan(
                chosenSection,
                this.mySharedPlans[sharedPlan],
                this.user,
                professional
              );
              this.router.navigate([navigateSection + chosenPlan["clientId"]]);
            } else {
              this.disableAccessButton(index);
            }
            break;
          case "wishes":
            if (
              this.mySharedPlans[sharedPlan].wishesPermission != "never" &&
              this.mySharedPlans[sharedPlan].wishesPermission != "future"
            ) {
              this.delegateHelpers.seeSharedPlan(
                chosenSection,
                this.mySharedPlans[sharedPlan],
                this.user,
                professional
              );
              this.router.navigate([navigateSection + chosenPlan["clientId"]]);
            } else {
              this.disableAccessButton(index);
            }
            break;
        }
      } else {
        console.log("Not delegate.");
      }
    }
  }

  visibleIndex = -1;
  disableAccessButton(ind) {
    if (this.visibleIndex === ind) {
      this.visibleIndex = -1;
    } else {
      this.visibleIndex = ind;
    }
  }

  async inviteClients() {
    // this.companyDetails = await this.professionalFeaturesService.companyDetails;
    // this.hideSponsor = this.companyDetails.hideSponsor;
    console.log("companyDetails - ", this.companyDetails);
    console.log("hideSponsor - ", this.hideSponsor);
    if (this.companyDetails && this.hideSponsor) {
      if (this.customers && this.customers.length == 0) {
        this.router.navigate(["/upload-professionals-list"]);
      } else {
        this.router.navigate(["/add-clients"]);
      }
    } else {
      this.router.navigate(["/create-account"], {
        state: { customers: this.customers },
      });
      console.log("customers", this.customers);
    }
  }

  insertText(selectedValue: string) {
    const disabledValues = [
      "Professional Referral Code",
      "Professional Referral Link",
    ];

    const textToInsert = `${selectedValue}`;
    const cursorPosition = this.textarea.nativeElement.selectionStart;
    const textBeforeCursor = this.textarea.nativeElement.value.substring(
      0,
      cursorPosition
    );
    const textAfterCursor =
      this.textarea.nativeElement.value.substring(cursorPosition);
    const newValue = textBeforeCursor + textToInsert + textAfterCursor;

    this.textarea.nativeElement.value = newValue;

    if (disabledValues.includes(selectedValue)) {
      setTimeout(() => {
        this.disableInsertedValue(selectedValue);
      }, 0);
    }
  }

  disableInsertedValue(selectedValue: string) {
    const textareaValue = this.textarea.nativeElement.value;
    const disabledStartTag = `<disabled>[`;
    const disabledEndTag = `]</disabled>`;

    const startIndex = textareaValue.indexOf(`[${selectedValue}]`);
    if (startIndex !== -1) {
      const endIndex = startIndex + selectedValue.length + 2;
      const disabledValue = disabledStartTag + selectedValue + disabledEndTag;
      this.textarea.nativeElement.value =
        textareaValue.substring(0, startIndex) +
        disabledValue +
        textareaValue.substring(endIndex);
    }
  }

  async statusModal(status: string, customerId: string) {
    this.modalCanBeOpened = true;
    this.selectedUserId = customerId;
    if (status === "prePopulated") {
      this.modalCanBeOpened = true;
      this.nudgeModalCanBeOpened = true;
      this.loadTemplates(status, customerId);
    } else if (status === "invited") {
      this.modalCanBeOpened = true;
      this.nudgeModalCanBeOpened = true;
      this.modalTitle = "Remind client to create a plan";
      this.loadTemplates(status);
    } else if (status === "created") {
      this.nudgeModalCanBeOpened = true;
      this.modalCanBeOpened = true;
      this.modalTitle = "Remind client to add you as a delegate";
      this.loadTemplates(status);
    }
  }

  async loadTemplates(status: string = "default", customerId?: string) {
    // Handle the "invited" and "created" statuses as before
    if (status == "invited") {
      const template = await this.api.getProfessionalInviteTemplateForModal(
        "nudge"
      );
      console.log("template: ", template);
      this.emailSubject = template.mail_template.subject;
      this.emailBody = template.mail_template.body;
      this.editableTemplateBody = this.extractContentFromBody(
        template.mail_template.body
      );
    }

    if (status == "created") {
      const template = await this.api.getProfessionalInviteTemplateForModal(
        "delegate_request_nudge"
      );
      console.log("template: ", template);
      this.emailSubject = template.mail_template.subject;
      this.emailBody = template.mail_template.body;
      this.editableTemplateBody = this.extractContentFromBody(
        template.mail_template.body
      );
    }

    // Handle the "prePopulated" status, checking if the nudge has been sent or not
    if (status == "prePopulated" && customerId) {
      // First, check if the nudge has been sent for the prePopulated user
      const isFirstNudge = await this.checkIfFirstNudge(customerId);

      // Default template for when nudge hasn't been sent
      let templateKey;
      // If the nudge has been sent, use the "delegate_shared_nudge" template
      if (isFirstNudge === "nudgeBeenSent") {
        this.modalTitle = "Remind client that their Zenplan is ready to view";
        templateKey = "delegate_shared_nudge";
        console.log("templateKey 2", templateKey);
      } else {
        this.modalTitle = "Notify client that you have created their plan";
        templateKey = "account_created_nudge";
        console.log("templateKey 1", templateKey);
      }

      // Load the appropriate template based on the nudge status
      const template = await this.api.getProfessionalInviteTemplateForModal(
        templateKey
      );
      console.log("templateKey + template :", templateKey, template);

      this.emailSubject = template.mail_template.subject;
      this.emailBody = template.mail_template.body;
      this.editableTemplateBody = this.extractContentFromBody(
        template.mail_template.body
      );
    }
  }

  async sendNudge(selectedUserId: any) {
    console.log("selectedUserId: ", selectedUserId);
    this.nudgeModalCanBeOpened = true; // Make sure the nudge modal is not opened yet

    // Find if the selectedUserId exists in filteredCustomers
    const selectedCustomer = this.filteredCustomers.find(
      (customer) => customer.Id === selectedUserId
    );

    if (!selectedCustomer) {
      console.log("User with the selected ID not found in filteredCustomers.");
      return;
    }

    // Check if userType is 'invited', and prevent the warning modal if true
    if (selectedCustomer.userType === "invited") {
      console.log(
        "User is of type 'invited', setting warningModalCanBeOpened to false..."
      );
      this.templateKey = "nudge";
      this.warningModalCanBeOpened = false;
    } else if (selectedCustomer.userType === "planHolder") {
      console.log(
        "User is of type 'planHolder', setting warningModalCanBeOpened to false..."
      );
      this.templateKey = "delegate_request_nudge";
      this.warningModalCanBeOpened = false;
    } else {
      // Check if the nudge has already been sent
      const isFirstNudge = await this.checkIfFirstNudge(selectedUserId);
      if (isFirstNudge === "NudgeNotBeenSent") {
        this.templateKey = "account_created_nudge";
      }
      if (isFirstNudge === "warningAlreadyShownButNudgeNotSent") {
        this.templateKey = "account_created_nudge";
      }
      if (isFirstNudge === "nudgeBeenSent") {
        this.templateKey = "delegate_shared_nudge";
      }
      console.log("isFirstNudge: ", isFirstNudge);

      // If the nudge hasn't been sent, open the warning modal unless userType is 'invited'
      if (
        isFirstNudge !== "nudgeBeenSent" &&
        isFirstNudge !== "warningAlreadyShown" &&
        isFirstNudge !== "warningAlreadyShownButNudgeNotSent" &&
        isFirstNudge !== undefined
      ) {
        console.log("Opening warning modal...");
        this.warningModalCanBeOpened = true;
      }
    }

    // Only send the nudge email if the warning modal cannot be opened
    if (!this.warningModalCanBeOpened) {
      console.log("Warning modal not opened, sending nudge email now...");
      await this.sendNudgeEmail(selectedUserId, this.templateKey);
    } else {
      console.log("Warning modal opened, not sending nudge email.");
    }
  }

  async checkIfFirstNudge(customerId: string): Promise<any> {
    try {
      // Find the customer in filteredCustomers by matching the customerId
      const customer = this.filteredCustomers.find(
        (cust) => cust.Id === customerId
      );

      // If no customer is found or the userType is not 'prePopulated', return false or any other value
      if (!customer || customer.userType !== "prePopulated") {
        return undefined; // Or return any other response like "notApplicable"
      }

      // Proceed with the existing logic if userType is 'prePopulated'
      const remoteStorage = await this.api.getRemoteStorage();
      const customerKey = customerId.replace(/-/g, "-"); // Ensure proper format if needed

      // Iterate through each entry in the remoteStorage array
      for (const entry of remoteStorage) {
        const nestedData = entry.data.data;

        if (nestedData[customerKey]) {
          const emailStatus = nestedData[customerKey].emailStatus;
          const warningShown = nestedData[customerKey].warningShown;
          const bannerToDisplayInSharedPlanSummary = nestedData[customerKey].bannerToDisplayInSharedPlanSummary;

          // If nudge has already been sent
          if (emailStatus && emailStatus.nudgeSent === true) {
            return "nudgeBeenSent";
          } else if (
            emailStatus &&
            emailStatus.nudgeSent === false &&
            warningShown === true
          ) {
            console.log("Warning shown but nudge not sent.");
            return "warningAlreadyShownButNudgeNotSent";
          } else if (
            emailStatus &&
            emailStatus.nudgeSent === true &&
            warningShown === true
          ) {
            console.log("Warning already shown and nudge sent.");
            return "warningAlreadyShown";
          } else if (bannerToDisplayInSharedPlanSummary && bannerToDisplayInSharedPlanSummary.nudgeSent === true) {
            console.log("Nudge already sent from banner in shared plan.");
            return "nudgeBeenSent";

          } else {
            // If neither nudge sent nor warning shown
            return "nudgeNotBeenSent";
          }
        }
      }

      return "nudgeNotBeenSent";
    } catch (error) {
      console.error("Error checking if first nudge:", error);
      return false;
    }
  }

  async understandWarning(userId) {
    // Close the warning modal
    const selectedUserId = userId; // Assuming you have this stored somewhere
    const emailStatusObject = {
      [selectedUserId]: {
        emailStatus: { nudgeSent: false }, // Nudge not sent yet
        warningShown: true, // Mark that the warning has been shown
      },
    };

    try {
      const response = await this.api.remoteStorage({
        data: emailStatusObject,
      });
      this.warningModalCanBeOpened = false;
      if (response && response.success) {
        this.templateKey = 'account_created_nudge';
        this.sendNudgeEmail(selectedUserId, this.templateKey);
        this.checkRemoteStorageForPrepopulatedUser();
      } else {
        console.error("Error updating remote storage:", response);
        alert(
          "There was a problem updating the status. Please try again later."
        );
      }
    } catch (error) {
      console.error("Error updating remote storage:", error);
      alert("There was a problem updating the status. Please try again later.");
    }
  }

  // Helper function to handle the actual nudge sending logic
  async sendNudgeEmail(selectedUserId: any, templateKey: string) {
    console.log("templateKey: ", templateKey);
    switch (templateKey) {
      case "nudge":
        this.nudgeEmailToSend.mode = "nudge";
        break;
      case "account_created_nudge":
        this.nudgeEmailToSend.mode = "account_created_nudge";
        break;
      case "delegate_shared_nudge":
        this.nudgeEmailToSend.mode = "delegate_shared_nudge";
        break;
      case "delegate_request_nudge":
        this.nudgeEmailToSend.mode = "delegate_request_nudge";
        break;
    }
    const textareaValue = this.textarea.nativeElement.value;
    this.nudgeEmailToSend.mailBody = this.insertContentIntoBody(
      textareaValue,
      this.emailBody
    );

    if (this.inputEmailSubject && this.inputEmailSubject.trim() !== "") {
      this.nudgeEmailToSend.mailSubject = this.inputEmailSubject;
    } else {
      this.nudgeEmailToSend.mailSubject = this.emailSubject;
    }

    this.nudgeEmailToSend.userList = [{ Id: selectedUserId }];

    

    try {
      if (templateKey !== 'nudge') {
        const emailStatusObject = {
          [selectedUserId]: {
            emailStatus: { nudgeSent: true },
          },
        };
        await this.api.remoteStorage({ data: emailStatusObject });
      }
      const response = await this.api.sendInvites(this.nudgeEmailToSend);
      if (response && response.success) {
        alert("Your message has been sent successfully!");
        this.checkRemoteStorageForPrepopulatedUser();
      }
      // Clear the inputs and close the modals
      this.inputEmailSubject = "";
      this.nudgeModalCanBeOpened = false;
      this.warningModalCanBeOpened = false;

      // Reload the pae for Not Shared so the right status is shown
      if (templateKey === "account_created_nudge") {
        window.location.href = window.location.pathname + "?section=clients";
      }
    } catch (error) {
      console.error(error);
      alert("There was a problem sending your nudge. Please try again later.");
    }
  }

  extractContentFromBody(htmlString) {
    let bodyContentRegex = /<div id="body">([\s\S]*?)<\/div>/;
    let match = bodyContentRegex.exec(htmlString);
    if (match) {
      let divContent = match[1];
      return divContent.replace(/<br>/gi, "\n");
    }
  }

  insertContentIntoBody(str: string, htmlString: string) {
    let html = str.replace(/\n/gi, "<br>");
    let updatedHtmlString = htmlString.replace(
      /(<div id="body">)([\s\S]*?)(<\/div>)/,
      `$1${html}$3`
    );
    // console.log("updatedHtmlString: ", updatedHtmlString);
    return updatedHtmlString;
  }

  inputChangeEmail(event: any, element: string) {
    if (element === "input") {
      this.inputEmailSubject = event.target.value;
      this.nudgeEmailToSend.mailSubject = this.inputEmailSubject;
    }
  }

  handleChangeSubject(value: string) {
    this.nudgeEmailToSend.mailSubject = value;
  }

  displayCurrentSection(section) {
    this.statusClientIssues = false;
    this.statusDelegateNetwork = true;
    this.statusMessages = false;
    this.statusCustomBlocks = false;
    this.statusTeamMembers = false;
    this.statusResources = false;

    switch (section) {
      case "clients":
        this.statusClientIssues = true;
        this.statusDelegateNetwork = false;
        break;
      case "delegate-network":
        this.statusDelegateNetwork = true;
        break;
      case "messages":
        this.statusMessages = true;
        this.statusDelegateNetwork = false;
        break;
      case "custom-blocks":
        this.statusCustomBlocks = true;
        this.statusDelegateNetwork = false;
        break;
      case "team-members":
        this.statusTeamMembers = true;
        this.statusDelegateNetwork = false;
        break;
      case "resources":
        this.statusResources = true;
        this.statusDelegateNetwork = false;
        break;
    }
    this.selectedSection = section;
  }

  async sortColumns(columnName: string) {
    switch (columnName) {
      case "firstName":
        this.firstNameSorted = !this.firstNameSorted;
        break;
      case "lastName":
        this.lastNameSorted = !this.lastNameSorted;
        break;
      case "linkedClient":
        this.linkedClientSorted = !this.linkedClientSorted;
        break;
      case "age":
        this.ageSorted = !this.ageSorted;
        break;
    }

    let sortingKey = "";
    switch (columnName) {
      case "firstName":
        sortingKey = this.firstNameSorted
          ? '{"delegateFirstName":-1}'
          : '{"delegateFirstName":1}';
        break;
      case "lastName":
        sortingKey = this.lastNameSorted
          ? '{"delegateLastName":-1}'
          : '{"delegateLastName":1}';
        break;
      case "linkedClient":
        sortingKey = this.linkedClientSorted ? '{"user":-1}' : '{"user":1}';
        break;
      case "age":
        sortingKey = this.ageSorted
          ? '{"delegateDOB":-1}'
          : '{"delegateDOB":1}';
        break;
    }

    this.sortedUsers = await this.api.getProfessionalsDelegates(sortingKey);
    console.log("sortedUsers - ", this.sortedUsers);

    this.professionalsDelegates = this.sortedUsers.filter(
      (dataUser) => this.companyDetails.email !== dataUser.delegateEmail
    );
    // this.originalProfessionalsDelegates.filter(
    //   (dataUser) => companyDetails.email !== dataUser.delegateEmail
    // );
  }

  openModal(user: any) {
    console.log("professionalsDelegates ", this.professionalsDelegates);
    console.log("userId ", user);
    this.selectedUserData = user; // Assign the clicked user, not the entire array
    console.log("selectedUserData ", this.selectedUserData);
    this.checkIfAnyConversations(this.selectedUserData);
  }

  async checkIfAnyConversations(selectedUser: any) {
    // To check if the user has any conversations - we want to see the latest messages
    this.retrievedMessages = await this.api.retrieveMessages();
    console.log("retrieveMessages: ", this.retrievedMessages);
    if (this.retrievedMessages.length > 0) {
      this.statusOpenModal = false;
    } else {
      this.statusOpenModal = true;
    }
    if (selectedUser) {
      console.log("selectedUser: ", selectedUser);
      // go over the this.retrievedMessages array and check if there are any recipientId or senderId who match the selectedUser delegateId
      let selectedUserDelegateId = selectedUser.delegateId;
      console.log("selectedUserDelegateId: ", selectedUserDelegateId);
      let selectedUserMessages = [];
      for (let i = 0; i < this.retrievedMessages.length; i++) {
        if (
          this.retrievedMessages[i].recipientId == selectedUserDelegateId ||
          this.retrievedMessages[i].senderId == selectedUserDelegateId
        ) {
          selectedUserMessages.push(this.retrievedMessages[i]);
        }
      }
      console.log("selectedUserMessages: ", selectedUserMessages);
      if (selectedUserMessages.length > 0) {
        this.statusOpenModal = false;
        this.displayCurrentSection("messages");
        this.statusRedirectionModal = false;
      }
    }
  }

  async sendMessage(message, recipientId) {
    console.log(message, recipientId);
    let result = await this.zpDataService.sendMessage(message, recipientId);
    console.log(result);
    if (result && result.success) {
      this.messageToSend =
        "Enter an introductory message to kick-start your new relationship!";
      this.messageHasBeenSent = true;
      setTimeout(() => {
        this.messageHasBeenSent = false;
        this.closeButton.nativeElement.click();
      }, 3000);
    } else {
      this.notifications.changeMessage(
        new ZPNotification("Message failed to send. Please try again later.")
      );
    }
  }

  // Check how many messages are in the inbox
  onGroupedMessagesLengthChange(length: number) {
    this.retrievedMessagesLength = length;
  }

  handleUnreadMessages(event?: {
    hasUnreadMessages: boolean;
    totalUnreadMessages: number;
  }) {
    // Check if event is defined
    if (event) {
      // Handle the event based on whether there are unread messages or not
      if (event.hasUnreadMessages) {
        // Update your parent component properties or perform any actions
        this.displayUnreadMessageBadge = true;
        this.displayCurrentSection("messages");
      } else {
        // Update your parent component properties or perform any actions
        this.displayUnreadMessageBadge = false;
      }

      // You can also access the total unread messages from event.totalUnreadMessages if needed
      this.totalUnreadMessages = event.totalUnreadMessages;
    } else {
      // Handle the case where event is undefined
      this.displayUnreadMessageBadge = false;
      console.log(
        "Event is undefined, setting displayUnreadMessageBadge to false."
      );
    }
  }

  async createAccountByClick(response?, user?: any) {
    this.modalTitle = "Create a Zenplan on behalf of your client";
    if (response == "create") {
      this.modalForClientCreation = true;

      console.log("user: ", user);
      this.userToBeCreated = user;
    }
    if (response == "yes") {
      // const getRemoteStorage = await this.api.getRemoteStorage();
      // console.log("getRemoteStorage:", getRemoteStorage);
      const response = await this.api.createPlanHolderByOneClick(
        this.userToBeCreated.Id
      );
      console.log("response:", response);
      if (response.success && response.success === true) {
        this.router.navigate([
          "/shared-plan-summary/" + this.userToBeCreated.Id,
        ]);
      }
    }
    this.modalForClientCreation = false;
  }

  openStatusExplanations() {
    this.openExplanationsForStatus = !this.openExplanationsForStatus;
  }
}
